var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _rect, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessTaxPostingGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 26H20V27H18.5V26Z",
    fill: "#1A35C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 26H22.5V27H21V26Z",
    fill: "#1A35C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 26H25V27H23.5V26Z",
    fill: "#1A35C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26H27.5V27H26V26Z",
    fill: "#1A35C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 24H20V25H18.5V24Z",
    fill: "#1A35C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24H22.5V25H21V24Z",
    fill: "#1A35C2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 24H25V25H23.5V24Z",
    fill: "#1A35C2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26 24H27.5V25H26V24Z",
    fill: "#1A35C2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22H20V23H18.5V22Z",
    fill: "#1A35C2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22H22.5V23H21V22Z",
    fill: "#1A35C2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22H25V23H23.5V22Z",
    fill: "#1A35C2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26 22H27.5V23H26V22Z",
    fill: "#1A35C2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 28H20V29H18.5V28Z",
    fill: "#1A35C2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28H22.5V29H21V28Z",
    fill: "#1A35C2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 28H25V29H23.5V28Z",
    fill: "#1A35C2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26 28H27.5V29H26V28Z",
    fill: "#1A35C2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 30H20V31H18.5V30Z",
    fill: "#1A35C2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30H22.5V31H21V30Z",
    fill: "#1A35C2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 30H25V31H23.5V30Z",
    fill: "#1A35C2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30H27.5V31H26V30Z",
    fill: "#1A35C2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 32H20V33H18.5V32Z",
    fill: "#1A35C2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21 32H22.5V33H21V32Z",
    fill: "#1A35C2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 32H25V33H23.5V32Z",
    fill: "#1A35C2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26 32H27.5V33H26V32Z",
    fill: "#1A35C2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 34H20V35H18.5V34Z",
    fill: "#1A35C2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26 34H27.5V35H26V34Z",
    fill: "#1A35C2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12 32H13V33H12V32Z",
    fill: "#1A35C2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14 32H15V33H14V32Z",
    fill: "#1A35C2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12 30H13V31H12V30Z",
    fill: "#1A35C2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30H15V31H14V30Z",
    fill: "#1A35C2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12 28H13V29H12V28Z",
    fill: "#1A35C2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14 28H15V29H14V28Z",
    fill: "#1A35C2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16H20.5V17H19.5V16Z",
    fill: "#1A35C2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16H22.5V17H21.5V16Z",
    fill: "#1A35C2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 16H24.5V17H23.5V16Z",
    fill: "#1A35C2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 16H26.5V17H25.5V16Z",
    fill: "#1A35C2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 18H20.5V19H19.5V18Z",
    fill: "#1A35C2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 18H22.5V19H21.5V18Z",
    fill: "#1A35C2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18H24.5V19H23.5V18Z",
    fill: "#1A35C2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 18H26.5V19H25.5V18Z",
    fill: "#1A35C2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12 34H13V35H12V34Z",
    fill: "#1A35C2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M14 34H15V35H14V34Z",
    fill: "#1A35C2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12 36H13V37H12V36Z",
    fill: "#1A35C2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M14 36H15V37H14V36Z",
    fill: "#1A35C2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32H34V33H33V32Z",
    fill: "#1A35C2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32H32V33H31V32Z",
    fill: "#1A35C2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30H34V31H33V30Z",
    fill: "#1A35C2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30H32V31H31V30Z",
    fill: "#1A35C2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M33 28H34V29H33V28Z",
    fill: "#1A35C2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28H32V29H31V28Z",
    fill: "#1A35C2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34H34V35H33V34Z",
    fill: "#1A35C2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M31 34H32V35H31V34Z",
    fill: "#1A35C2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M33 36H34V37H33V36Z",
    fill: "#1A35C2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36H32V37H31V36Z",
    fill: "#1A35C2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 9H24C23.8888 8.99999 23.7808 9.03706 23.6931 9.10535L19.1931 12.6053C19.1329 12.6521 19.0843 12.7119 19.0508 12.7803C19.0174 12.8487 19 12.9239 19 13V14H18C17.8674 14 17.7402 14.0527 17.6465 14.1465C17.5527 14.2402 17.5 14.3674 17.5 14.5V20H16.5C16.3674 20 16.2402 20.0527 16.1465 20.1465C16.0527 20.2402 16 20.3674 16 20.5V26H10.5C10.3674 26 10.2402 26.0527 10.1465 26.1465C10.0527 26.2402 10 26.3674 10 26.5V38.5C10 38.6326 10.0527 38.7598 10.1465 38.8535C10.2402 38.9473 10.3674 39 10.5 39H35.5C35.6326 39 35.7598 38.9473 35.8535 38.8535C35.9473 38.7598 36 38.6326 36 38.5V26.5C36 26.3674 35.9473 26.2402 35.8535 26.1465C35.7598 26.0527 35.6326 26 35.5 26H30V20.5C30 20.3674 29.9473 20.2402 29.8535 20.1465C29.7598 20.0527 29.6326 20 29.5 20H28.5V14.5C28.5 14.3674 28.4473 14.2402 28.3535 14.1465C28.2598 14.0527 28.1326 14 28 14H27V9.5C27 9.36739 26.9473 9.24022 26.8535 9.14645C26.7598 9.05269 26.6326 9.00001 26.5 9V9ZM11 27H16V38H11V27ZM35 27V38H30V27H35ZM20 13.2446L24.1716 10H26V14H20V13.2446ZM22 38V35H24V38H22ZM29 38H25V34.5C25 34.3674 24.9473 34.2402 24.8535 34.1465C24.7598 34.0527 24.6326 34 24.5 34H21.5C21.3674 34 21.2402 34.0527 21.1465 34.1465C21.0527 34.2402 21 34.3674 21 34.5V38H17V21H29V38ZM27.5 20H18.5V15H27.5V20Z",
    fill: "#1A35C2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 21,
    width: 13,
    height: 19,
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4008 27.7996C31.6217 27.7996 31.8008 27.6205 31.8008 27.3996V25.3996H32.6008C32.8217 25.3996 33.0008 25.2205 33.0008 24.9996C33.0008 24.7787 32.8217 24.5996 32.6008 24.5996H30.2008C29.9799 24.5996 29.8008 24.7787 29.8008 24.9996C29.8008 25.2205 29.9799 25.3996 30.2008 25.3996H31.0008V27.3996C31.0008 27.6205 31.1799 27.7996 31.4008 27.7996Z",
    fill: "#DC332E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7565 27.5803L33.8485 27.4002H35.3524L35.4444 27.5803C35.5122 27.7146 35.6499 27.7998 35.8005 27.8002C35.8632 27.801 35.9251 27.7857 35.9806 27.7562C36.1767 27.6564 36.2552 27.4168 36.1565 27.2201L34.9565 24.8201C34.888 24.6865 34.7505 24.6025 34.6005 24.6025C34.4505 24.6025 34.313 24.6865 34.2444 24.8201L33.0444 27.2201C32.964 27.4137 33.0464 27.6363 33.2333 27.7309C33.4202 27.8254 33.6485 27.7598 33.7565 27.5803ZM34.6005 25.8963L34.9524 26.6002H34.2485L34.6005 25.8963Z",
    fill: "#DC332E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M39.684 24.716C39.609 24.6402 39.5066 24.5977 39.4 24.5977C39.2934 24.5977 39.191 24.6402 39.116 24.716L38.2 25.6359L37.284 24.716C37.1271 24.5592 36.8729 24.5592 36.716 24.716C36.5592 24.8729 36.5592 25.1271 36.716 25.284L37.6359 26.2L36.716 27.116C36.6402 27.191 36.5977 27.2934 36.5977 27.4C36.5977 27.5066 36.6402 27.609 36.716 27.684C36.791 27.7598 36.8934 27.8023 37 27.8023C37.1066 27.8023 37.209 27.7598 37.284 27.684L38.2 26.7641L39.116 27.684C39.191 27.7598 39.2934 27.8023 39.4 27.8023C39.5066 27.8023 39.609 27.7598 39.684 27.684C39.7598 27.609 39.8023 27.5066 39.8023 27.4C39.8023 27.2934 39.7598 27.191 39.684 27.116L38.7641 26.2L39.684 25.284C39.7598 25.209 39.8023 25.1066 39.8023 25C39.8023 24.8934 39.7598 24.791 39.684 24.716Z",
    fill: "#DC332E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4 41.4C41.1791 41.4 41 41.5791 41 41.8V43C41 43.6627 40.4627 44.2 39.8 44.2C39.1373 44.2 38.6 43.6627 38.6 43V41.8C38.6 41.5791 38.4209 41.4 38.2 41.4H28.6V23C28.6 22.3373 29.1373 21.8 29.8 21.8H41.4C41.1383 22.1451 40.9977 22.5668 41 23V30.6C41 30.8209 41.1791 31 41.4 31C41.6209 31 41.8 30.8209 41.8 30.6V26.2H44.6C44.8209 26.2 45 26.0209 45 25.8V23C45 21.8955 44.1045 21 43 21H29.8C28.6955 21 27.8 21.8955 27.8 23V41.4H25.4C25.1791 41.4 25 41.5791 25 41.8V43C25 44.1045 25.8955 45 27 45H39.8C40.9045 45 41.8 44.1045 41.8 43V41.8C41.8 41.5791 41.6209 41.4 41.4 41.4ZM44.2 23V25.4H41.8V23C41.8 22.3373 42.3373 21.8 43 21.8C43.6627 21.8 44.2 22.3373 44.2 23ZM27 44.2C26.3373 44.2 25.8 43.6627 25.8 43V42.2H37.8V43C37.8 43.4328 37.9404 43.8537 38.2 44.2H27Z",
    fill: "#1A35C2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4009 37.8C41.0695 37.8 40.8009 37.5314 40.8009 37.2C40.8009 36.9791 40.6218 36.8 40.4009 36.8C40.18 36.8 40.0009 36.9791 40.0009 37.2C40.0034 37.817 40.4095 38.3598 41.0009 38.5359V39C41.0009 39.2209 41.18 39.4 41.4009 39.4C41.6218 39.4 41.8009 39.2209 41.8009 39V38.5359C42.4693 38.3408 42.8915 37.683 42.7909 36.9939C42.6902 36.3051 42.0972 35.7957 41.4009 35.8C41.0695 35.8 40.8009 35.5314 40.8009 35.2C40.8009 34.8686 41.0695 34.6 41.4009 34.6C41.7323 34.6 42.0009 34.8686 42.0009 35.2C42.0009 35.4209 42.18 35.6 42.4009 35.6C42.6218 35.6 42.8009 35.4209 42.8009 35.2C42.7984 34.583 42.3923 34.0402 41.8009 33.8641V33.4C41.8009 33.1791 41.6218 33 41.4009 33C41.18 33 41.0009 33.1791 41.0009 33.4V33.8641C40.3325 34.0592 39.9103 34.717 40.0109 35.4061C40.1116 36.0949 40.7046 36.6043 41.4009 36.6C41.7323 36.6 42.0009 36.8686 42.0009 37.2C42.0009 37.5314 41.7323 37.8 41.4009 37.8Z",
    fill: "#DC332E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4001 31.7998C40.5374 31.7986 39.6938 32.0533 38.976 32.5318C38.8286 32.593 38.7317 32.7361 38.7295 32.8959C38.7274 33.0555 38.8204 33.2012 38.9661 33.2664C39.112 33.3316 39.2825 33.3039 39.4001 33.1959C40.9405 32.1713 43.0069 32.4813 44.179 33.9125C45.351 35.3439 45.2475 37.4309 43.9393 38.7391C42.6311 40.0473 40.5442 40.1508 39.1127 38.9787C37.6815 37.8066 37.3715 35.7402 38.3961 34.1998C38.4913 34.0816 38.5114 33.9197 38.4479 33.7818C38.3846 33.6439 38.2485 33.5537 38.0967 33.549C37.9452 33.5443 37.8038 33.626 37.7321 33.7598C37.2506 34.4822 36.9958 35.3316 37.0001 36.1998C37.0001 38.6299 38.97 40.5998 41.4001 40.5998C43.8301 40.5998 45.8001 38.6299 45.8001 36.1998C45.8001 33.7697 43.8301 31.7998 41.4001 31.7998V31.7998Z",
    fill: "#1A35C2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7996 29.8004C39.7996 29.5795 39.6205 29.4004 39.3996 29.4004H32.9996C32.7787 29.4004 32.5996 29.5795 32.5996 29.8004C32.5996 30.0213 32.7787 30.2004 32.9996 30.2004H39.3996C39.6205 30.2004 39.7996 30.0213 39.7996 29.8004Z",
    fill: "#1A35C2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6012 31.4004H30.6012C30.3803 31.4004 30.2012 31.5795 30.2012 31.8004C30.2012 32.0213 30.3803 32.2004 30.6012 32.2004H36.6012C36.8221 32.2004 37.0012 32.0213 37.0012 31.8004C37.0012 31.5795 36.8221 31.4004 36.6012 31.4004Z",
    fill: "#1A35C2"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8012 34.2004C36.0221 34.2004 36.2012 34.0213 36.2012 33.8004C36.2012 33.5795 36.0221 33.4004 35.8012 33.4004H34.6012C34.3803 33.4004 34.2012 33.5795 34.2012 33.8004C34.2012 34.0213 34.3803 34.2004 34.6012 34.2004H35.8012Z",
    fill: "#1A35C2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2012 35.8004C30.2012 36.0213 30.3803 36.2004 30.6012 36.2004H35.4012C35.6221 36.2004 35.8012 36.0213 35.8012 35.8004C35.8012 35.5795 35.6221 35.4004 35.4012 35.4004H30.6012C30.3803 35.4004 30.2012 35.5795 30.2012 35.8004Z",
    fill: "#1A35C2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4004 37.4004H31.8004C31.5795 37.4004 31.4004 37.5795 31.4004 37.8004C31.4004 38.0213 31.5795 38.2004 31.8004 38.2004H35.4004C35.6213 38.2004 35.8004 38.0213 35.8004 37.8004C35.8004 37.5795 35.6213 37.4004 35.4004 37.4004Z",
    fill: "#1A35C2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6012 40.2004H37.0012C37.2221 40.2004 37.4012 40.0213 37.4012 39.8004C37.4012 39.5795 37.2221 39.4004 37.0012 39.4004H30.6012C30.3803 39.4004 30.2012 39.5795 30.2012 39.8004C30.2012 40.0213 30.3803 40.2004 30.6012 40.2004Z",
    fill: "#1A35C2"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0012 33.4004H30.6012C30.3803 33.4004 30.2012 33.5795 30.2012 33.8004C30.2012 34.0213 30.3803 34.2004 30.6012 34.2004H33.0012C33.2221 34.2004 33.4012 34.0213 33.4012 33.8004C33.4012 33.5795 33.2221 33.4004 33.0012 33.4004Z",
    fill: "#1A35C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessTaxPostingGroup);
export default __webpack_public_path__ + "static/media/business-tax-posting-group.64e415ffc4d6ff552b5c9139bf42dabb.svg";
export { ForwardRef as ReactComponent };